import createTableStore from "ds/components/Table/store/useTableStore";

import { SLACK_TABLE_COLUMNS_CONFIG, SLACK_TABLE_STORAGE_KEY } from "./constants";

const useSlackTableStore = createTableStore({
  storageKey: SLACK_TABLE_STORAGE_KEY,
  config: SLACK_TABLE_COLUMNS_CONFIG,
});

export default useSlackTableStore;
